var _defs, _g, _path, _path2, _g2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMissionBooster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_354_752",
    x1: 13.9139,
    y1: 22.8382,
    x2: 10.0933,
    y2: 1.16864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FB496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_354_752",
    x1: 11.8625,
    y1: 16.8,
    x2: 12.271,
    y2: 0.628789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FB496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_354_752",
    x1: 11.9721,
    y1: 9.06153,
    x2: 11.9585,
    y2: 21.2099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FB496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_354_752",
    x1: 10.8342,
    y1: 10.7046,
    x2: -0.704767,
    y2: 1.47116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FB496"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0036 23.0036C18.0788 23.0036 23.0036 18.0788 23.0036 12.0036C23.0036 5.9285 18.0788 1.00363 12.0036 1.00363C5.9285 1.00363 1.00364 5.9285 1.00364 12.0036C1.00364 18.0788 5.9285 23.0036 12.0036 23.0036Z",
    fill: "url(#paint0_linear_354_752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9856 3.08595C7.10225 3.08595 3.14356 7.04464 3.14356 11.928C3.14356 16.8113 7.10225 20.77 11.9856 20.77C16.8689 20.77 20.8276 16.8113 20.8276 11.928C20.8276 7.04464 16.8689 3.08595 11.9856 3.08595Z",
    fill: "url(#paint1_linear_354_752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.969 6.18982C8.80582 6.18982 6.24174 8.75389 6.24174 11.9171C6.24174 15.0803 8.80582 17.6444 11.969 17.6444C15.1322 17.6444 17.6963 15.0803 17.6963 11.9171C17.6963 8.75389 15.1322 6.18982 11.969 6.18982Z",
    fill: "url(#paint2_linear_354_752)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9856 21.0777C6.94036 21.0777 2.83636 16.9732 2.83636 11.928C2.83636 6.88276 6.9408 2.77876 11.9856 2.77876C17.0304 2.77876 21.1348 6.8832 21.1348 11.928C21.1348 16.9728 17.0304 21.0777 11.9856 21.0777ZM11.9856 3.39316C7.27942 3.39316 3.45076 7.22182 3.45076 11.928C3.45076 16.6342 7.27942 20.4628 11.9856 20.4628C16.6918 20.4628 20.5204 16.6342 20.5204 11.928C20.5204 7.22182 16.6918 3.39316 11.9856 3.39316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.969 17.952C8.64131 17.952 5.93455 15.2448 5.93455 11.9175C5.93455 8.59026 8.64175 5.88306 11.969 5.88306C15.2963 5.88306 18.0035 8.59026 18.0035 11.9175C18.0035 15.2448 15.2963 17.952 11.969 17.952ZM11.969 6.49746C8.98036 6.49746 6.54894 8.92888 6.54894 11.9175C6.54894 14.9062 8.98036 17.3376 11.969 17.3376C14.9577 17.3376 17.3891 14.9062 17.3891 11.9175C17.3891 8.92888 14.9577 6.49746 11.969 6.49746Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.495623 4.49402L2.73898 6.28783C2.78792 6.32679 2.84953 6.3468 2.91219 6.34329L4.20744 6.27098C4.26976 6.26747 4.33137 6.28713 4.38031 6.32574L11.5772 11.8644C11.7779 12.0242 12.0694 11.9971 12.2373 11.8037C12.4151 11.5991 12.3863 11.288 12.174 11.1188L4.92389 5.53274C4.86616 5.48676 4.83165 5.4183 4.82848 5.34494L4.78236 4.21564C4.77919 4.14227 4.74469 4.07417 4.68731 4.02819L2.48408 2.26632C2.31192 2.12871 2.05738 2.26 2.07111 2.47975L2.14505 3.65959C2.1535 3.7965 2.0514 3.9155 1.91409 3.92779L0.63152 4.04328C0.403382 4.06364 0.317126 4.35114 0.495623 4.49402Z",
    fill: "url(#paint3_linear_354_752)",
    stroke: "white",
    strokeWidth: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 7.99941L8.7928 12.319C8.7208 12.4756 8.83513 12.6545 9.00793 12.6545H10.6185C10.7735 12.6545 10.8865 12.8007 10.8476 12.9508L10.0242 16.1271C9.96226 16.3671 10.2633 16.529 10.4292 16.3449L15.1271 11.1321C15.2663 10.9776 15.1528 10.7311 14.9447 10.7367L12.8689 10.7934C12.6969 10.7982 12.5778 10.6241 12.6442 10.4653L13.6146 8.14429C13.6805 7.98676 13.5627 7.81309 13.3916 7.81614L10.9908 7.86109C10.9 7.86283 10.818 7.9165 10.78 7.99898L10.7809 7.99941Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionBooster);
export default __webpack_public_path__ + "static/media/icon-mission-booster.0bad41e1f446834edd416a6e7fceeffc.svg";
export { ForwardRef as ReactComponent };